// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { TimerScheduleOperation_abstract } from './../../abstract/SagaBase/Defines/TimerScheduleOperation_abstract';
export class TimerScheduleOperation extends TimerScheduleOperation_abstract {}
